import { Link } from "@StarberryUtils";
import React, { useEffect, useState } from "react";
import { Col, Row, Container, Modal } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import TapiEmbed from "./TapiEmbed/TapiEmbed"

// Embed_URL pointing at Tapi (e.g. https://eu.tapi.app/embed/bot/web?management_id=...) renders the Tenant Concierge
const getTapiManagementId = (url) => {
    if (!url || url.indexOf("tapi.app") < 0) return null
    const match = url.match(/[?&]management_id=([^&#]+)/)
    return match ? decodeURIComponent(match[1]) : null
}

function Fixflow(props) {

    const Layout = props?.Layout !== 'Homepage';
    const [show, setShow] = useState(true);

    return (
        <div className="content">
            {props.Modules.map((Modules, i) => {
                const tapiManagementId = getTapiManagementId(Modules.Embed_URL)
                return (
                    <>
                    {Modules.Embed_URL && Layout &&
                        <Container className="fixflow-div">
                            <Row>
                                <Col lg={12}>
                                    <div className="fixflow">
                                        {Modules.Intro_Content ?
                                            <ReactMarkdown source={Modules.Intro_Content} allowDangerousHtml className="editor"/> : ''
                                        }
                                        {tapiManagementId ?
                                            <TapiEmbed managementId={tapiManagementId} /> :
                                            <iframe src={Modules.Embed_URL}></iframe>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    }

                {Modules.Popup_Content && <Modal
                show={show}
                onHide={() => setShow(false)}
                className="fixflow-popup"
                >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body>
                        {Modules.Popup_Content &&
                        <ReactMarkdown source={Modules.Popup_Content} allowDangerousHtml className="editor"/>
                        }
                        {Modules.Popup_CTA_Text &&
                        <button className="btn btn-primary" onClick={() => setShow(false)}>{Modules.Popup_CTA_Text}</button>
                        }
                    </Modal.Body>
                </Modal>
                }

                    </>
                )
            })}
        </div>
    )
}

export default Fixflow
